import { render, staticRenderFns } from "./tabTableActions.vue?vue&type=template&id=53d692e0&"
import script from "./tabTableActions.vue?vue&type=script&lang=js&"
export * from "./tabTableActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports